export const getNewOrder = (prevItem, nextItem, items) => {
    if (!nextItem) {
        return (Math.max(...items.map(({ order }) => Number(order) || 0)) || 0) + 1;
    }

    return ((Number(prevItem?.order) || 0) + (Number(nextItem.order) || 1)) / 2;
}
